<!-- 顶部菜单组件 -->
<template>
    <div class="top-menu">
        <div class="left">
            <div class="info-cont">
                <h2 class="tab-title">{{menuInfo.title}}</h2>
                <p class="intro" v-for="item in menuInfo.intro">{{ item.title }}</p>
                <div class="list-cont">
                    <div class="item" v-for="item in menuInfo.list">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.text }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div :class="item.title?'main':''" v-for="item in menuArr">
                <h2 class="cate-title">{{ item.title }}</h2>
                <div class="main-cont">
                    <div class="category-cont" v-for="cate in item.categoryList">
                        <div class="category-title">{{ cate.title }}</div>
                        <div class="category-list">
                            <p :class="$route.path===menu.path?'active':''" v-for="menu in cate.list" @click="handleJump(menu.path)">{{ menu.title }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        menuInfo:{
            type:Object,
            default:function(){
                return {
                    title:'顶部菜单',
                    intro:[
                        {
                            title:'用心服务'
                        }
                    ],
                    list:[
                        {
                            title:'标签标题',
                            text:'标签内容'
                        }
                    ]
                }
            }
        },
        menuArr:{
            type:Array,
            default:function(){
                return [
                    {
                        title:'',//非必填,menu分类
                        categoryList:[
                            {
                                title:'面向企业',
                                // 分类子menu
                                list:[
                                    {
                                        title:'ERP管理系统',
                                        path:''
                                    },
                                    {
                                        title:'MES管理系统',
                                        path:''
                                    },

                                ]
                            }
                        ]
                    }
                ]
            }
        }
    },
    methods: {
        handleJump(path) {
            if(path&&this.$route.path!==path){
                this.$router.push(path)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.top-menu {
    width: 100%;
    height: 500px;
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 9427;
    display: flex;


    .left {
        width: 620px;
        height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 43px 0 0 204px;



        .info-cont {
            width: 100%;
            box-sizing: border-box;
            padding: 0 40px 0 86px;
            position: relative;
            height: 100%;
            background: url('@/assets/images/top-menu/banner.png') no-repeat 0 100%;


            // .bg {
            //     position: absolute;
            //     right: 0;
            //     bottom: 0;
            //     width: 100%;
            // }

            h2.tab-title {
                font-weight: bold;
                font-size: 1.125rem;
                color: #2B2B2B;
                line-height: 24px;
                margin-bottom: 12px;
            }

            p.intro {
                font-weight: 400;
                font-size: .875rem;
                color: #5C6170;
                line-height: 24px;
            }

            div.list-cont {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                margin-top: 48px;

                .item {
                    min-width: 48%;
                    height: 64px;
                    box-sizing: border-box;
                    border: 1px solid #ECECEC;
                    box-sizing: border-box;
                    padding: 10px;

                    >h3 {
                        font-weight: 400;
                        font-size: .875rem;
                        color: #191C3D;
                        line-height: 20px;
                    }

                    >p {
                        font-weight: 500;
                        font-size: .75rem;
                        color: #191C3D;
                        line-height: 20px;

                    }
                }
            }
        }


    }

    .right {
        width: calc(100% - 620px);
        height: 100%;
        background: #F1F2F5;
        box-sizing: border-box;
        padding: 30px;

        .cate-title {
            font-weight: 400;
            font-size: 1rem;
            color: #000000;
            margin-bottom: 6px;
        }

        .main {
            width: 100%;
            height: 50%;
        }

        .main-cont {
            width: 100%;
            height: calc(100% - 27px);
            display: flex;
            flex-wrap: wrap;
            gap: 28px;
            

            .category-cont {
                min-width: 140px;
                height: 175px;

                .category-title {
                    font-weight: 400;
                    width: 100%;
                    border-bottom: 1px solid #ddd;
                    font-size: .875rem;
                    color: #006CFF;
                    line-height: 30px;
                    margin-bottom: 6px;
                }

                .category-list {
                    width: 100%;
                    height: calc(100% - 37px);
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;


                    >p {

                        height: 25%;
                        box-sizing: border-box;
                        font-weight: 400;
                        font-size: .75rem;
                        color: #5C6170;
                        margin-right: 20px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        &:hover,&.active {
                            color: #5392E8;
                        }

                    }
                }
            }
        }

    }
}
</style>